import { render, staticRenderFns } from "./CKRecord.vue?vue&type=template&id=204da168&scoped=true&"
import script from "./CKRecord.vue?vue&type=script&lang=js&"
export * from "./CKRecord.vue?vue&type=script&lang=js&"
import style0 from "./CKRecord.vue?vue&type=style&index=0&id=204da168&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204da168",
  null
  
)

export default component.exports